import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = "plans/subscriptions";

export class SubscriptionsService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listStatus(params?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/status/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listCancellationMotives(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`${URL}/cancellation/motives`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async cancel(motiveId: number, description?: string): Promise<any[]> {
    try {
      const body: { motive_id: number; description?: string } = { motive_id: motiveId };
      if (description) body.description = description;
      return this.handleResponse(await api.post(`${URL}/cancel`, body));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
